import Types from "../../action/types";


const defaultState = {
    userEmail: {},
    userInfo: {}, //登录返回的回调数据
    emailToken: {},//发送验证码返回的token
    signUpModal: {
        visible: false,
        counts: 0,
        step: 0
    },
    isLogin: {
        value: false
    },
    keepAlive: {

    }
};

export default function onAction(state = defaultState, action) {
    switch (action.type) {
        case Types.LOGININ:
            return { ...state, userInfo: action.userInfo }
        case Types.SENDVERIFICATION:
            return { ...state, emailToken: action.emailToken }
        case Types.SAVEEMAIL:
            return { ...state, userEmail: action.userEmail }
        case Types.SIGNUPMODAL_CHANGE:
            return { ...state, signUpModal: action.signUpModal }
        case Types.ISLOGIN:
            return { ...state, isLogin: action.payload }
        case Types.KEEPALIVE:
            return { ...state, keepAlive: action.keepAlive }
        default:
            return state
    }
}